export const serverCallTimeout: number = 3000;
export const searchTermTimeout: number = 450;
